















































































































































































































import { Component, Vue } from "vue-property-decorator";
import axios from 'axios';
import LottieAnimation from 'lottie-web-vue';
import MetaSearchAgency from '@/store/entities/metaSearchAgency';

@Component({
  components: {
    LottieAnimation,
  }
})
export default class QueryTool extends Vue {
  origin: string = '';
  destination: string = '';
  departureDate: string = '';
  arrivalDate: string = '';
  departureDateMenu: boolean = false;
  arrivalDateMenu: boolean = false;
  adultCount: number = 1;
  childCount: number = 0;
  infantCount: number = 0;
  currencyId: string = 'EUR';
  refId: number = 189; // CharterScanners'ın ID'si
  valid: boolean = false;
  rules = {
    required: (value: any) => !!value || 'Required.',
  };
  flightGroups: any[] = [];
  breadcrumbsItems: any[] = [];
  searchPerformed: boolean = false;
  isLoading: boolean = false;
  metaSearchAgencies: any[] = [];
  private cancelTokenSource: any = null;

  get sortedRefIdOptions() {
    if (!this.metaSearchAgencies || this.metaSearchAgencies.length === 0) {
      return [];
    }
    
    return this.metaSearchAgencies
      .map((agency: any) => ({
        id: agency.refId, // RefId property'sini id olarak kullan
        name: agency.referrerId // ReferrerId property'sini name olarak kullan
      }))
      .filter(option => option.id && option.name) // Geçersiz değerleri filtrele
      .sort((a, b) => a.name.localeCompare(b.name));
  }

  calculateTotalPrice(flightGroup: any[]) {
    const total = flightGroup.reduce((total, flight) => total + flight.price, 0);
    return total.toFixed(2);
  }

  formatDateTime(dateTimeString: string) {
    const date = new Date(dateTimeString);
    return `${date.toLocaleDateString()} ${date.toLocaleTimeString()}`;
  }

  async submitForm() {
    if (this.cancelTokenSource) {
      this.cancelTokenSource.cancel();
    }
    this.cancelTokenSource = axios.CancelToken.source();

    this.searchPerformed = true;
    this.isLoading = true;
    this.flightGroups = [];

    const params = {
      origin: this.origin,
      destination: this.destination,
      departureDate: this.departureDate,
      arrivalDate: this.arrivalDate || null,
      adultCount: this.adultCount,
      childCount: this.childCount,
      infantCount: this.infantCount,
      currencyId: this.currencyId,
      refId: this.refId,
    };

    try {
      const response = await axios.post(
        'https://api.charterscanners.com/api/services/app/flight/Search',
        params,
        { cancelToken: this.cancelTokenSource.token }
      );
      if (response.data.success && response.data.result.flights) {
        this.flightGroups = Object.values(response.data.result.flights);
      } else {
        console.error("No flights found or invalid response");
      }
    } catch (error) {
      if (!axios.isCancel(error)) {
        console.error("Error fetching data:", error);
      }
    } finally {
      this.isLoading = false;
    }
  }

  async created() {
    this.breadcrumbsItems = [
      { text: "Ana Sayfa", disabled: false, href: "/#/main/home" },
      { text: "Uçuş", disabled: true },
      { text: "Query Tool", disabled: true },
    ];
    
    // MetaSearchAgency verilerini yükle
    await this.getMetaSearchAgencies();
  }
  
  async getMetaSearchAgencies() {
    try {
      // ServisMarkup modülündeki getMetaSearchAgencies methodunu kullan
      const result = await this.$store.dispatch('servisMarkup/getMetaSearchAgencies');
      this.metaSearchAgencies = result.items || result || [];
      console.log('MetaSearchAgencies result:', result);
    } catch (error) {
      console.error('Error loading MetaSearchAgencies:', error);
      // Fallback olarak metaSearchAgency modülünü dene
      await this.$store.dispatch({
        type: "metaSearchAgency/getMetaSearchAgencies",
        data: { pageSize: 100, currentPage: 1 }
      });
      this.metaSearchAgencies = this.$store.state.metaSearchAgency.list;
    }
  }
}
